export class MissingDeviceCredentialError extends Error {}

export class MissingRefreshTokenError extends Error {}
